/**
 * Close the cart drawer when the shopper clicks anywhere outside it.
 *
 * On narrow viewports Horizon opens the drawer as a modal with a backdrop, and
 * a backdrop click already closes it. On wide viewports (>= 990px) it opens as
 * a non-modal sidebar that squeezes the page, and Horizon never closes it from
 * an outside click. This fills that gap for the cart drawer only.
 *
 * Left alone on purpose: the header cart toggle (it opens and closes itself),
 * add-to-cart and quick-add controls (adding keeps the drawer open and updates
 * it), and anything inside another open dialog, popover, or drawer.
 */
const SIDEBAR_QUERY = window.matchMedia('(min-width: 990px)');

const IGNORED_TARGETS = [
  '[aria-controls="cart-drawer"]',
  '[on\\:click*="#cart-drawer/"]',
  'add-to-cart-component',
  'quick-add-component',
  'sticky-add-to-cart',
  '[name="add"]',
  'dialog[open]',
  '[popover]:popover-open',
  'theme-drawer:not(#cart-drawer)',
].join(', ');

/**
 * @param {MouseEvent} event
 * @returns {boolean} Whether the click landed on an element's own scrollbar.
 */
function isScrollbarClick(event) {
  const target = event.target;
  if (!(target instanceof HTMLElement)) return false;
  return event.offsetX > target.clientWidth || event.offsetY > target.clientHeight;
}

document.addEventListener(
  'click',
  (event) => {
    if (!SIDEBAR_QUERY.matches) return;

    const drawer = /** @type {(HTMLElement & { close?: Function }) | null} */ (document.getElementById('cart-drawer'));
    if (!drawer || !drawer.hasAttribute('open') || typeof drawer.close !== 'function') return;

    const target = event.target;
    if (!(target instanceof Element) || !target.isConnected) return;
    if (drawer.contains(target)) return;
    if (target.closest(IGNORED_TARGETS)) return;
    if (isScrollbarClick(event)) return;

    // Keep focus on whatever the shopper just clicked instead of pulling it
    // back to the cart icon.
    drawer.close({ restoreFocus: false });
  },
  { capture: true }
);
